import Link from "@/components/no-prefetch-link";

export function Footer() {
  return (
    <footer className="border-t mt-auto">
      <div className="container mx-auto px-4 py-6">
        {/* 主区域 */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* 品牌 */}
          <div className="flex items-center gap-2">
            <span className="text-xl">🔥</span>
            <div>
              <span className="font-semibold">热搜时光机</span>
              <span className="text-xs text-muted-foreground ml-2 hidden sm:inline">weibotop.cn</span>
            </div>
          </div>

          {/* QQ群 + 打赏 - 突出但简洁 */}
          <div className="flex items-center gap-3">
            <a
              href="https://jq.qq.com/?_wv=1027&k=nZIcjTG7"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full bg-blue-50 text-blue-600 hover:bg-blue-100 dark:bg-blue-950/30 dark:text-blue-400 dark:hover:bg-blue-950/50 transition-colors"
            >
              <span className="text-sm">💬</span>
              QQ交流群
            </a>
            <a
              href="https://qr.alipay.com/tsx02040f31mrddj5rjwh03"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full bg-orange-50 text-orange-600 hover:bg-orange-100 dark:bg-orange-950/30 dark:text-orange-400 dark:hover:bg-orange-950/50 transition-colors"
            >
              <span className="text-sm">☕</span>
              <span className="hidden sm:inline">支持作者</span>
              <span className="sm:hidden">打赏</span>
            </a>
          </div>

          {/* 版权 */}
          <p className="text-xs text-muted-foreground text-center md:text-right">
            © {new Date().getFullYear()} 热搜时光机 · 7000万+数据 · 6年+运行
          </p>
        </div>

        <nav
          aria-label="站点信息"
          className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 border-t border-dashed pt-4 text-xs"
        >
          <Link href="/search" className="text-muted-foreground hover:text-primary">
            历史热搜查询
          </Link>
          <Link
            href="/guides/weibo-hot-search-history"
            className="text-muted-foreground hover:text-primary"
          >
            查询指南
          </Link>
          <Link
            href="/guides/hot-search-engine"
            className="text-muted-foreground hover:text-primary"
          >
            热搜引擎说明
          </Link>
          <Link href="/about" className="text-muted-foreground hover:text-primary">
            关于热搜时光机
          </Link>
          <Link
            href="/methodology"
            className="text-muted-foreground hover:text-primary"
          >
            数据方法
          </Link>
        </nav>

        {/* 法律链接 */}
        <nav
          aria-label="法律信息"
          className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs"
        >
          <Link href="/privacy" className="text-muted-foreground hover:text-primary">
            隐私政策
          </Link>
          <Link href="/terms" className="text-muted-foreground hover:text-primary">
            服务条款
          </Link>
          <Link href="/cookies" className="text-muted-foreground hover:text-primary">
            Cookie 政策
          </Link>
        </nav>

        {/* QQ群引导文字 */}
        <div className="mt-3 text-center">
          <p className="text-xs text-muted-foreground">
            ★ 加入QQ交流群 953368107 — 与开发者交流新功能与反馈
          </p>
        </div>
      </div>
    </footer>
  );
}
